import { render, staticRenderFns } from "./OppositeInsurance.vue?vue&type=template&id=c9c427d0&scoped=true"
import script from "./OppositeInsurance.vue?vue&type=script&lang=js"
export * from "./OppositeInsurance.vue?vue&type=script&lang=js"
import style0 from "./OppositeInsurance.vue?vue&type=style&index=0&id=c9c427d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9c427d0",
  null
  
)

export default component.exports